export const questionnaireRoute = 'fragebogen';
export const appointmentRoute = 'termin';
